import RackSynth from 'instruments/synth/RackSynth.js';
import HasModulators from "modulators/HasModulators.js";
import ParameterContext from 'effects/ParameterContext.js';
import {MULTI_SYNTH} from 'constants/instrument-types.js';
import InstrumentTrack from './InstrumentTrack.js';

class MultiSynthTrack extends HasModulators(InstrumentTrack) {
    constructor(
        trackNumber,
        sequencerEngine,
        mixSession,
        numberOfPatterns,
        update,
        subSequence,
        createSynth=false
    ) {
        super(
            trackNumber,
            sequencerEngine,
            mixSession,
            numberOfPatterns,
            update,
            subSequence,
            false);

        this.initModulators();

        if (createSynth) {
            this.setInstrument(
                new RackSynth(
                    sequencerEngine,
                    mixSession,
                    new ParameterContext().forTrack(this),
                    this));
        }
    }

    getInstrumentType() {
        return MULTI_SYNTH;
    }

    createNewInstrument() {
        this.instrument = undefined;
        this.setInstrument(new RackSynth(
                this.sequencerEngine,
                this.mixSession,
                new ParameterContext().forTrack(this),
            this));
    }


    getAllParameters(includeEffects=true) {
        let parameters = super.getAllParameters(includeEffects);

        return [
            ... parameters,
            ... this.lfosTrack.lfos.flatMap(
                lfo => lfo.lfo.parameters),
            ... this.envelopesTrack.envelopes.flatMap(
                env => env.envelope.parameters),
        ];
    }

    getCopy(constr, sequencerEngine=this.sequencerEngine, ignoreId) {
        return super.getCopy((a,b,c,d,e,f) => new MultiSynthTrack(a,b,c,d,e,f, false), sequencerEngine, ignoreId);
    }


}

export default MultiSynthTrack;
